import { QueryClient } from 'react-query';

/**
 * Every query that reads money on the Profit page (and the Dashboard's
 * MoneyToday card). A write to a job cost, a bank sort, a typed cash cost or a
 * bank pull can move any of them — /money/month's job costs and overhead,
 * /money/today's month so far, /money/spending's unsorted count, the /profit
 * job cards, the bank inbox and Needs Attention — so they are refreshed
 * together. String keys prefix-match array keys (['money-month', '2026-09'],
 * ['profit', params], ['job-expenses', id] …).
 */
const MONEY_KEYS = [
  'profit', 'overhead', 'money-month', 'money-today', 'money-spending',
  'expenses-inbox', 'expenses-summary', 'job-expenses', 'attention',
];

export function invalidateMoney(qc: QueryClient) {
  MONEY_KEYS.forEach(k => qc.invalidateQueries(k));
}
